import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getBundleManagementList() {
  let res:any[] = []
  await Api.get(endpoints.getBundleManagement).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(`Could not get bundle list`)
  })

  return res
}

export async function saveBundleManagement(payload: any) {
  await Api.post(endpoints.saveBundleManagement, payload).then((response) => {
    if(response.status === 200 || response.data.return) {
      if(response.data.error || (response.data.return !== null && response.data.return === false)) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces(`Bundle successfully updated`)
      }
    }
  }).catch((err: string) => {
    notificationError(`Could not update bundle list`)
  })
}
